import React from "react"
import { FaMusic, FaMicrophone, FaMix } from "react-icons/all"

const services = [
    {
        id: 1,
        title: "Production",
        descr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
        icon: <FaMusic className="icon" />
    },
    {
        id: 2,
        title: "Recording",
        descr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
        icon: <FaMicrophone className="icon" />
    },
    {
        id: 3,
        title: "Mixing and Mastering",
        descr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque auctor pulvinar urna eget. Libero porttitor lectus orci odio.",
        icon: <FaMix className="icon" />
    },
]

export default services